// extracted by mini-css-extract-plugin
export default {"image":"CropControl_image__xt4fu","container":"CropControl_container__KCRPr"};